import { wrap as withStyle, themeColor } from 'utils/styles'

export default withStyle(
  (props) => `
    stroke: ${themeColor('black', props)};
    stroke-width: 2px;

    > * {
      stroke: ${themeColor('black', props)};
    }

    g {
      fill: ${themeColor('black', props)} !important;
      opacity: 0.5;
    }
  `
)
